import { BaseApi } from './base';
import type { UserTransaction } from './types';

export interface CreateTransactionPayload {
  destinationId: string;
  amount: number;
  description: string;
}

export class TransactionsApi extends BaseApi {
  public async getCurrentUserBalance(): Promise<number> {
    const response = await this._request<{ balance: number }>(
      '/transactions/current-user-balance',
      {
        method: 'GET',
      },
    );

    return response.balance;
  }

  public async create(payload: CreateTransactionPayload): Promise<void> {
    await this._request<void>('/transactions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
  }

  public async getForUser(
    userId: string,
    page: number,
    limit = 15,
  ): Promise<{
    transactions: UserTransaction[];
    hasMore: boolean;
    nextPage: number | null;
  }> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    return await this._request<{
      transactions: UserTransaction[];
      hasMore: boolean;
      nextPage: number | null;
    }>(`/users/${userId}/transactions?${params.toString()}`, {
      method: 'GET',
    });
  }
}
